<div class="modal-header">
    <h2 class="modal-title">{{'adminUsers.filterPopup.title' | translate}}</h2>
    <button type="button" class="btn-close" aria-label="Close" (click)="closeHandler()">
    </button>
</div>

<div class="modal-body">
    <div class="alert alert-info custom-alert" role="alert">
        <div class="alert-body d-flex align-items-center">
            <i class="app-icon icon icon-info-circle-fill text-info icon-xl me-4"></i>
            <span class="alert-text custom-alert-text" [innerHTML]="'email.filterAlert' | translate"> 
            </span>
        </div>
    </div>

    <div>
        <div class="d-flex align-items-center mb-3 pb-1">
            <input 
                class="checkbox-input" 
                type="checkbox"
                id="allAssetDocumentRequestTypes"
                name="allAssetDocumentRequestTypes" 
                [rounded]="rounded" 
                [size]="size"
                kendoCheckBox 
                [(ngModel)]="allAssetDocumentRequestTypes"
                (ngModelChange)="onAllRequestTypeCheckboxChange($event, dictionaryAssetDocumentRequestTypes, assetDocumentRequestTypeCheckboxStates, selectedDictionaryAssetDocumentRequestTypeIds)"
            >
            <label for="allAssetDocumentRequestTypes" class="ms-2 request-type-title cursor-pointer">{{'email.assetDocuments' | translate}}</label>
        </div>

        <div class="request-types-container">
            <div class="d-flex align-items-center" *ngFor="let requestType of dictionaryAssetDocumentRequestTypes">
                <input 
                    class="checkbox-input" 
                    type="checkbox"
                    [id]="'ad-'+requestType.code"
                    [name]="'ad-'+requestType.code" 
                    [rounded]="rounded" 
                    [size]="size"
                    kendoCheckBox 
                    [(ngModel)]="assetDocumentRequestTypeCheckboxStates[requestType.id]"
                    (change)="allAssetDocumentRequestTypes = onRequestTypeCheckboxChange(requestType.id, dictionaryAssetDocumentRequestTypes, assetDocumentRequestTypeCheckboxStates, selectedDictionaryAssetDocumentRequestTypeIds)"
                >
                <label [for]="'ad-'+requestType.code" class="ms-2 cursor-pointer">{{ requestType.value }}</label>
            </div>
        </div>
    </div>

    <div class="l-separator"></div>

    <div>
        <div class="d-flex align-items-center mb-3 pb-1">
            <input 
                class="checkbox-input" 
                type="checkbox"
                id="allContractModificationRequestTypes"
                name="allContractModificationRequestTypes" 
                [rounded]="rounded" 
                [size]="size"
                kendoCheckBox 
                [(ngModel)]="allContractModificationRequestTypes"
                (ngModelChange)="onAllRequestTypeCheckboxChange($event, dictionaryContractModificationRequestTypes, contractModificationRequestTypeCheckboxStates, selectedDictionaryContractModificationRequestTypeIds)"
            >
            <label for="allContractModificationRequestTypes" class="ms-2 request-type-title cursor-pointer">{{'email.contractModification' | translate}}</label>
        </div>

        <div class="request-types-container">
            <div class="d-flex align-items-center" *ngFor="let requestType of dictionaryContractModificationRequestTypes">
                <input 
                    class="checkbox-input" 
                    type="checkbox"
                    [id]="'cm-'+requestType.code"
                    [name]="'cm-'+requestType.code" 
                    [rounded]="rounded" 
                    [size]="size"
                    kendoCheckBox 
                    [(ngModel)]="contractModificationRequestTypeCheckboxStates[requestType.id]"
                    (change)="allContractModificationRequestTypes = onRequestTypeCheckboxChange(requestType.id, dictionaryContractModificationRequestTypes, contractModificationRequestTypeCheckboxStates, selectedDictionaryContractModificationRequestTypeIds)"
                >
                <label [for]="'cm-'+requestType.code" class="ms-2 cursor-pointer">{{ requestType.value }}</label>
            </div>
        </div>
    </div>

    <div class="l-separator"></div>

    <div>
        <div class="d-flex align-items-center mb-3 pb-1">
            <input 
                class="checkbox-input" 
                type="checkbox"
                id="allClientDataRequestTypes"
                name="allClientDataRequestTypes" 
                [rounded]="rounded" 
                [size]="size"
                kendoCheckBox 
                [(ngModel)]="allClientDataRequestTypes"
                (ngModelChange)="onAllRequestTypeCheckboxChange($event, dictionaryClientDataRequestTypes, clientDataRequestTypeCheckboxStates, selectedDictionaryClientDataRequestTypeIds)"
            >
            <label for="allClientDataRequestTypes" class="ms-2 request-type-title cursor-pointer">{{'email.myData' | translate}}</label>
        </div>

        <div class="request-types-container">
            <div class="d-flex align-items-center" *ngFor="let requestType of dictionaryClientDataRequestTypes">
                <input 
                    class="checkbox-input" 
                    type="checkbox"
                    [id]="'cd-'+requestType.code"
                    [name]="'cd-'+requestType.code" 
                    [rounded]="rounded" 
                    [size]="size"
                    kendoCheckBox 
                    [(ngModel)]="clientDataRequestTypeCheckboxStates[requestType.id]"
                    (change)="allClientDataRequestTypes = onRequestTypeCheckboxChange(requestType.id, dictionaryClientDataRequestTypes, clientDataRequestTypeCheckboxStates, selectedDictionaryClientDataRequestTypeIds)"
                >
                <label [for]="'cd-'+requestType.code" class="ms-2 cursor-pointer">{{ requestType.value }}</label>
            </div>
        </div>
    </div>
</div>

<div class="modal-footer">
    <button class="btn link-btn" (click)="resetHandler()">
        <i class="app-icon icon icon-reload icon-lg me-2"></i> 
        {{'adminUsers.filterPopup.reset' | translate}}
    </button>
    <button class="btn primary-btn" (click)="applyHandler()">
        {{'adminUsers.filterPopup.apply' | translate}}
    </button>
</div>